import { Alert, AlertDescription, AlertIcon, Flex, FlexProps, Image, Text } from "@chakra-ui/react";
import { textStyle, variant } from "theme/names";
import { refreshProfilePic } from "../../controllers/bookmark";
interface Props {
  people: any[];
  align?: "start" | "center" | "end";
  noOfImagePreview?: number;
  mainContainerProps?: FlexProps
}

export function Preview({ people, align = "center", noOfImagePreview = 10, mainContainerProps = {} }: Props) {
  return (
    <Flex
      mt="4"
      alignItems="center"
      justifyContent={align}
      {...mainContainerProps}
    >
      {people.length > 0 ? (
        <Flex alignItems={"center"} ml="12px">
          {people.slice(0, noOfImagePreview).map((p) => (
            <Image
              src={p?.image ?? p?.zFull?.profile_picture}
              alt="profile image"
              key={p.id}
              borderRadius="50%"
              h="8"
              w="8"
              mx="1"
              fallbackSrc={((p?.zFull?.profile_picture) ? p?.zFull?.profile_picture : "/emptyProfile.png")}
              ml={people.length > 1 ? "-12px" : ""}
              border="1px solid white"
              onError={async (e) => {
                const tweet = {
                  user: {
                    id_str: p?.id
                  },
                  id_str: ""
                }
                refreshProfilePic(tweet, "linkedin", "", false);
              }}
            />
          ))}
          {people.length > noOfImagePreview && (
            <Text
              textStyle={textStyle["body.medium.light"]}
              ml="2"
            // fontWeight="bold"
            >
              and {people.length - noOfImagePreview} more
            </Text>
          )}
        </Flex>
      ) : (
        <Text textStyle={textStyle["body.medium.light"]}>
          <Alert variant={variant.Alert.withIcons} status="info">
            <AlertIcon />
            <AlertDescription>
              No person added yet!
            </AlertDescription>
          </Alert>
        </Text>
      )}
    </Flex>
  );
}